import { type JSX } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import AvenyTheme from './AvenyTheme';

interface IProps {
  children: JSX.Element;
}

/**
 * Ställer in temat för applikationen. Hela Aveny ligger innanför en sådan här och gör att komponenter som ska anpassa sig efter värden på t.ex. färger får tillgång till dem.
 * Hårdkodad till att använda AvenyTheme i Const/AvenyTheme
 */
const EDThemeProvider = (props: IProps) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={AvenyTheme}>{props.children}</ThemeProvider>
  </StyledEngineProvider>
);

export default EDThemeProvider;
